import { PAYEX_URL } from 'constants/config';
import { decamelizeKeys } from 'humps';
import type { User } from 'models/user';
import { fetchJson, fetchWithAuthentication } from 'utils/fetchJson/fetchJson';

import type {
  ChangePasswordPayload,
  LogInPayload,
  LogInResponse,
  RefreshTokenPayload,
  ResetPasswordPayload,
  SignupRequestBody,
  SignupResponseBody,
} from './types';

export const auth = {
  signup: (data: SignupRequestBody, locale: string) => {
    const path = `${PAYEX_URL}/auth/signup?locale=${locale}`;

    const options = {
      method: 'POST',
      body: JSON.stringify(decamelizeKeys(data)),
    };

    return fetchJson<SignupResponseBody>(path, options);
  },
  logIn: ({ ...payload }: LogInPayload) => {
    const path = `${PAYEX_URL}/auth/token`;
    const body = JSON.stringify(payload);

    return fetchJson<LogInResponse>(path, { method: 'POST', body });
  },
  refreshToken: ({ ...payload }: RefreshTokenPayload) => {
    const path = `${PAYEX_URL}/auth/token`;
    const body = JSON.stringify(payload);

    return fetchJson<LogInResponse>(path, { method: 'POST', body });
  },
  resetPassword: ({ userEmail }: ResetPasswordPayload) => {
    const path = `${PAYEX_URL}/auth/reset_password`;
    const body = JSON.stringify({
      email: userEmail,
    });

    const options = {
      method: 'POST',
      body,
    };

    return fetchJson(path, options);
  },
  changePassword: (payload: ChangePasswordPayload) => {
    const path = `${PAYEX_URL}/auth/change_password`;
    const body = JSON.stringify(payload);

    const options = {
      method: 'POST',
      body,
    };

    return fetchWithAuthentication<
      Pick<User, 'email' | 'firstName' | 'lastName'>
    >(path, options);
  },
};
